export const Fields = Object.freeze({
  id: 'id',
  subjectName: 'Предмет',
  pairTime: 'Время',
  lessonTypeName: 'Тип урока',
  departmentName: 'Кафедра',
  dayName: 'День недели',
  weekNumber: 'Номер недели',
  groupTypeName: 'Тип группы',
  lectorName: 'Лектор',
  auditoryNumber: 'Аудитория',
  locationAddress: 'Адрес',
  semester: 'Семестр',
  courseNumber: 'Курс',
  speciality: 'Специальность',
  academicYear: 'Год',
  groupStream: 'Поток',
  studyGroup: 'Группа',
  subgroup: 'Подгруппа',
  stream: 'Поток',
  lessonType: 'Тип занятий'
})

export const Models = Object.freeze({
  auditoryNumber: 'auditoryNumber',
  dayName: 'dayName',
  departmentName: 'departmentName',
  groupTypeName: 'groupTypeName',
  lectorName: 'lectorName',
  locationAddress: 'locationAddress',
  pairTime: 'pairTime',
  studyGroup: 'studyGroup',
  subgroup: 'subgroup',
  subjectName: 'subjectName',
  weekNumber: 'weekNumber',
  groupStream: 'groupStream',
  lessonType: 'lessonType',
  stream: 'stream',
  speciality: 'speciality',
  courseNumber: 'courseNumber',
  academicYear: 'academicYear',
  semester: 'semester'
})
